import gql from 'graphql-tag';

/**
 * Data requests: a school asks a group of students to fill in profile fields
 * by a date, follows who has answered and reminds the rest. Students answer
 * on their profile form.
 */
export const STUDENT_DATA_REQUEST_FIELDS = gql`
  fragment StudentDataRequestFields on StudentDataRequest {
    id title message due_on status is_overdue
    blocks_portal lock_on_close include_late_joiners
    created_by_name created_at closed_at
    recipients_count completed_count viewer_can_manage
    fields { key label required }
    audience { all_students classroom_ids section_ids programme_ids student_ids label }
  }
`;

export const GET_STUDENT_DATA_REQUESTS = gql`
  query StudentDataRequests($status: StudentDataRequestStatus) {
    studentDataRequests(status: $status) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const GET_STUDENT_DATA_REQUEST = gql`
  query StudentDataRequest($id: ID!) {
    studentDataRequest(id: $id) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const GET_STUDENT_DATA_REQUEST_RECIPIENTS = gql`
  query StudentDataRequestRecipients(
    $request_id: ID!, $filter: StudentDataRequestRecipientFilter, $search: String, $first: Int, $page: Int
  ) {
    studentDataRequestRecipients(request_id: $request_id, filter: $filter, search: $search, first: $first, page: $page) {
      data { student_id student_name matric_no class_name completed_at last_reminded_at reminder_count missing }
      paginatorInfo { currentPage lastPage perPage total }
    }
  }
`;

export const GET_STUDENT_DATA_REQUEST_AUDIENCE_COUNT = gql`
  query StudentDataRequestAudienceCount($audience: StudentDataRequestAudienceInput!) {
    studentDataRequestAudienceCount(audience: $audience)
  }
`;

export const GET_STUDENT_DATA_REQUEST_FIELD_CHOICES = gql`
  query StudentDataRequestFieldChoices {
    studentDataRequestFieldChoices { key label }
  }
`;

export const GET_MY_STUDENT_DATA_REQUESTS = gql`
  query MyStudentDataRequests {
    myStudentDataRequests {
      id title message due_on is_overdue blocks_portal completed
      fields { key label required filled fillable }
    }
  }
`;

export const CREATE_STUDENT_DATA_REQUEST = gql`
  mutation CreateStudentDataRequest($input: CreateStudentDataRequestInput!) {
    createStudentDataRequest(input: $input) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const UPDATE_STUDENT_DATA_REQUEST = gql`
  mutation UpdateStudentDataRequest($id: ID!, $input: UpdateStudentDataRequestInput!) {
    updateStudentDataRequest(id: $id, input: $input) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const CLOSE_STUDENT_DATA_REQUEST = gql`
  mutation CloseStudentDataRequest($id: ID!) {
    closeStudentDataRequest(id: $id) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const REOPEN_STUDENT_DATA_REQUEST = gql`
  mutation ReopenStudentDataRequest($id: ID!, $due_on: Date) {
    reopenStudentDataRequest(id: $id, due_on: $due_on) { ...StudentDataRequestFields }
  }
  ${STUDENT_DATA_REQUEST_FIELDS}
`;

export const REMIND_STUDENT_DATA_REQUEST = gql`
  mutation RemindStudentDataRequest($id: ID!, $student_ids: [ID!]) {
    remindStudentDataRequest(id: $id, student_ids: $student_ids)
  }
`;
